import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=be014252"
import script from "./Favorites.vue?vue&type=script&lang=ts"
export * from "./Favorites.vue?vue&type=script&lang=ts"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=be014252&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be014252')) {
      api.createRecord('be014252', component.options)
    } else {
      api.reload('be014252', component.options)
    }
    module.hot.accept("./Favorites.vue?vue&type=template&id=be014252", function () {
      api.rerender('be014252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Favorites.vue"
export default component.exports